<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="secteurForm" @submit="editSecteur" :validation-schema="secteurSchema">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Libellé <span class="text-danger">*</span>
              </label>
              <Field name="libelle" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrez le libellé du secteur" />
              <ErrorMessage name="libelle" class="text-danger" />
            </div>
          </div>
          <!-- <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Statut
              </label>
              <div class="form-check">
                <Field name="statut" type="checkbox" :value="true" class="form-check-input" id="statut" />
                <label class="form-check-label text-black fw-semibold" for="statut">
                  Actif
                </label>
              </div>
            </div>
          </div> -->
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Description <span class="text-danger">*</span>
              </label>
              <Field name="description" as="textarea" rows="3" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrez la description du secteur" />
              <ErrorMessage name="description" class="text-danger" />
            </div>
          </div>
          <div class="col-md-12">
            <div class="d-flex align-items-center">
              <button class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit">
                Modifier
              </button>
              <router-link to="/liste-secteuractivites"
                class="btn btn-danger transition border-0 lh-1 fw-medium">
                <i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import { useRoute, useRouter } from "vue-router";
import ApiService from "../../services/ApiService";
import { error, success } from "../../utils/utils";

export default defineComponent({
  name: "EditSecteurActivite",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  setup() {
    const secteurSchema = Yup.object().shape({
      libelle: Yup.string().required("Le libellé est obligatoire"),
      description: Yup.string().required("La description est obligatoire"),
    });

    const secteurForm = ref<any>(null);
    const router = useRouter();
    const route = useRoute();
    const secteurId = Number(route.params.id);

    const getSecteur = async (id: number) => {
      try {
        const response = await ApiService.get(`/secteuractivites/${id}`);
        const data = response.data.data;
        secteurForm.value?.setFieldValue("libelle", data.libelle);
        secteurForm.value?.setFieldValue("description", data.description);
        secteurForm.value?.setFieldValue("statut", data.statut === true);
      } catch (err: any) {
        console.error("Erreur:", err);
        error(err.response?.data?.message || "Erreur lors du chargement");
      }
    };

    const editSecteur = async (values: any, { resetForm }) => {
      try {
        values.statut = values.statut === true;
        const { data } = await ApiService.put(`/secteuractivite/${secteurId}`, values);
        if (data.code === 200) {
          success(data.message);
          router.push("/liste-secteuractivites");
        }
      } catch (err: any) {
        console.error("Erreur update secteur :", err);
        error(err.response?.data?.message || "Erreur lors de la modification");
      }
    };

    onMounted(() => {
      if (secteurId && !isNaN(secteurId)) {
        getSecteur(secteurId);
      }
    });

    return {
      secteurSchema,
      editSecteur,
      secteurForm,
    };
  },
});
</script>
